import { NavigationGuard } from 'vue-router';
import store from '@/store';
import Vue from 'vue';

const vueTrackingInstance = new Vue();

export const summaryResolver: NavigationGuard = async (_to, _from, next) => {
  await store.dispatch('summary/setInfo');
  await store.dispatch('summary/updateRoutes');

  vueTrackingInstance.$gtm.trackConfigurationCreated();

  next();
};
